import { useQuery } from '@tanstack/react-query';
import api from '@/services/api.service';
import { useAuthStore } from '@/store/authStore';

function unwrap<T>(res: unknown): T {
  const data = (res as any)?.data ?? res;
  return (data?.data ?? data) as T;
}

/** Shared prefix — use invalidateQueries({ queryKey: ['notifications'] }) after inbox changes. */
export const NOTIFICATIONS_QUERY_PREFIX = ['notifications'] as const;

/**
 * Unread in-app notification count for the bell badge (same source as My Alerts inbox).
 */
export function useUnreadNotificationCount() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  return useQuery({
    queryKey: [...NOTIFICATIONS_QUERY_PREFIX, 'unread-count'],
    queryFn: async () => {
      const res = await api.get('/notifications/unread-count');
      const body = unwrap<{ count?: number }>(res);
      return typeof body?.count === 'number' ? body.count : 0;
    },
    enabled: isAuthenticated,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
